// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.v-dialog__content .v-dialog[data-v-24e1bdc0] .v-card,
.application .theme--light.v-stepper[data-v-24e1bdc0],
.theme--light .v-stepper[data-v-24e1bdc0] {
  background: #fafafa;
}
.v-dialog[data-v-24e1bdc0] .v-stepper {
  background: inherit;
}
.v-dialog .v-stepper[data-v-24e1bdc0] .v-stepper__header {
  box-shadow: none;
  text-transform: uppercase;
}
.v-dialog .v-stepper[data-v-24e1bdc0] .v-stepper__content {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 0;
}
.application .theme--light.v-stepper .v-stepper__step--editable[data-v-24e1bdc0]:hover,
.theme--light .v-stepper .v-stepper__step--editable[data-v-24e1bdc0]:hover {
  background: none;
}
.shadow-outer[data-v-24e1bdc0] {
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
}
.enquiry-step3[data-v-24e1bdc0] {
  width: 240px;
}
.v-form > .container > .layout[data-v-24e1bdc0]:only-child {
  margin: 0;
}
.v-input__slot[data-v-24e1bdc0] {
  margin-bottom: 0;
}
.v-text-field__details[data-v-24e1bdc0] {
  color: inherit;
  display: flex;
  padding-top: 4px;
  flex: 1 0 100%;
  font-size: 12px;
  min-height: 26px;
  overflow: hidden;
  position: relative;
  width: 100%;
  align-items: center;
}
.policy-logo[data-v-24e1bdc0] {
  width: 118px;
  height: 100%;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
  position: relative;
}
.policy-logo img[data-v-24e1bdc0] {
  padding: 0px 15px;
  width: 100%;
  margin: auto;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.emergency-info-table[data-v-24e1bdc0] {
  width: 100%;
  padding-left: 15px;
}
.emergency-info-table .shadow-outer.emergency-table[data-v-24e1bdc0] {
  height: 100%;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
